export { M200Profile as default } from './M200Profile';
